import { add, clamp } from '@immutabl3/utils';

const { abs } = Math;
const { NEGATIVE_INFINITY, POSITIVE_INFINITY } = Number;

export const height = beakers => {
  let h = 0;
  for (const { height } of beakers.values()) h += height;
  return h;
};

export const duration = beakers => {
  return Array.from(beakers.values())
    .map(({ duration }) => duration)
    .reduce(add, 0);
};

const secToHeight = (sec, height, duration) => {
  const perc = abs(sec) / duration;
  return ~~(height * perc);
};

export const scrollPerc = (scrollTop, top, height) => {
  const scroll = scrollTop - top;
  const perc = scroll / height;
  return clamp(perc, NEGATIVE_INFINITY, POSITIVE_INFINITY);
};

export const beakerPositions = (beakers, initialTop = 0) => {
  let top = initialTop;
  const map = new Map();
  for (let idx = 0; idx < beakers.length; idx++) {
    const beaker = beakers[idx];
    
    if (beaker.config.offsetTop) {
      const prevBeaker = beakers[idx - 1];
      if (prevBeaker) {
        const ot = secToHeight(
          beaker.config.offsetTop,
          prevBeaker.height,
          prevBeaker.config.duration,
        );
        top -= ot;
      }
    }

    map.set(beaker.id, top);
    top += beaker.height;
  }
  return map;
};